import { render, staticRenderFns } from "./DossierActivityDomainsTable.vue?vue&type=template&id=6dbbe796&scoped=true"
import script from "./DossierActivityDomainsTable.vue?vue&type=script&lang=ts"
export * from "./DossierActivityDomainsTable.vue?vue&type=script&lang=ts"
import style0 from "./DossierActivityDomainsTable.vue?vue&type=style&index=0&id=6dbbe796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbe796",
  null
  
)

export default component.exports